export * from "@trpc/react-query/shared";

export const ENDPOINTS = [
  "loggedInViewerRouter",
  "admin",
  "apiKeys",
  "apps",
  "auth",
  "availability",
  "billing",
  "appBasecamp3",
  "bookings",
  "calendars",
  "calVideo",
  "credentials",
  "deploymentSetup",
  "eventTypes",
  "eventTypesHeavy",
  "features",
  "feedback",
  "holidays",
  "featureOptIn",
  "i18n",
  "insights",
  "me",
  "ooo",
  "organizations",
  "payments",
  "public",
  "timezones",
  "teams",
  "slots",
  "travelSchedules",
  "users",
  "viewer",
  "webhook",
  "googleWorkspace",
  "oAuth",
  "workflows",
  "delegationCredential",
  "credits",
  "filterSegments",
  "phoneNumber",
] as const;
